module.exports = __webpack_public_path__ + "img/icon-multichannel.b3d7cd71.svg";